import { render, staticRenderFns } from "./ociFooter.vue?vue&type=template&id=47f68fa0&"
import script from "./ociFooter.vue?vue&type=script&lang=js&"
export * from "./ociFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports